import { useCallback, useState } from "react";
import { useReportApi, unwrapReport } from "../api/reportApi";

// #947 — Score Admin's "open the rider's score page" affordance, available
// from every rider/ride screen and the class menu. Calls report-api's authed
// GET /score-sheets/rides/:rideId/link, which silently ensures the rider's
// permanent score-sheet page exists (create-or-reuse, same flow as the public
// rider portal #621/#630 and #822's auto-on-Place fan-out) and returns its
// URL — unlike useResendScoreSheet, this NEVER emails the rider and never
// forces a re-render, so it's safe to call just to look at/copy the link.
export function useScorePageLink() {
  const reportApi = useReportApi();
  const [loading, setLoading] = useState(false);

  // Resolves to the score-page URL string (or throws — callers decide how to
  // surface a failure, e.g. "not configured" in an env with no rider-sheets
  // pilot set up).
  const getLink = useCallback(
    async (rideId) => {
      setLoading(true);
      try {
        const res = await reportApi.riderSheets.getScorePageLink(rideId);
        const data = unwrapReport(res);
        return data?.url;
      } finally {
        setLoading(false);
      }
    },
    [reportApi],
  );

  return { getLink, loading };
}

export default useScorePageLink;
